import CrossReferencedField from "./CrossReferencedField";

export default class CrossReferencedDHWField extends CrossReferencedField {

    constructor(name, step) {
        super(name, step, 'dhw')

    }

    //canCrossReferencedFieldBeAccessed() {
    //    return Boolean(this.getDHW())
    //}

    //getCrossReferencedField() {
    //    return this.getDHW().getField(this.name)
    //}

    //getDHW() {
    //    let stepsManager = this.getConfigurator().getStepsManager()
    //    return stepsManager.getStepByName('dhw')
    //}
}
